import { UserManager, WebStorageStateStore } from "oidc-client-ts";

// Dev Cognito pool (us-east-1_NWCSLH4ri). Production values will be added separately.
export const cognitoUserPoolId = "us-east-1_NWCSLH4ri";
export const cognitoDomain = "qe-upt-auth-dev.auth.us-east-1.amazoncognito.com";
export const cognitoClientId = "a2vfbquavp4h3m2v0f9oeselq";

export const getRedirectUri = () =>
  `https://${window.location.hostname}/signin-callback`;

export const getLogoutUrl = () =>
  `https://${cognitoDomain}/logout?client_id=${cognitoClientId}&logout_uri=${encodeURIComponent(
    `${window.location.origin}/`,
  )}`;

export const createUserManager = () =>
  new UserManager({
    authority: `https://cognito-idp.us-east-1.amazonaws.com/${cognitoUserPoolId}`,
    client_id: cognitoClientId,
    redirect_uri: getRedirectUri(),
    response_type: "code",
    scope: "openid profile email",
    loadUserInfo: true,
    automaticSilentRenew: false,
    disablePKCE: false,
    stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
  });
